import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";


import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';

import { IoEyeOutline } from "react-icons/io5";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import { FaGoogle } from "react-icons/fa";

import Card from 'react-bootstrap/Card';
import Swal from 'sweetalert2'

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';

let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const SignUpPage = ({signUp, loggedIn}) => {  
    const navigate = useNavigate(); 
    
    const [swalProps, setSwalProps] = useState({});

    const [formData, setFormData] = useState({
        email: "",
		full_name: "",
		password: "",
		confirm_password: "",
		mobile_number: "",
		member_type: "",
    });

	const [ errors, setErrors ] = useState({});
    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setConfirmShowPass] = useState(false);
	const [passwordType, setPasswordType] = useState('password');
	const [confirmpasswordType, setConfirmPasswordType] = useState('password');
	
	const [processing, setProcessing] = useState(false);
	const [ responseError, setResponseError ] = useState();

    useEffect(() => {
		if(loggedIn){
			window.location.href = '/';
		}
	},[loggedIn]);

    const handleChange = (e) => { 
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });  
        findFormErrors();
    }

    const showPassword = () => {
		if(!showPass){
		  setPasswordType('text');
		} else {
		  setPasswordType('password');
		}
		setShowPass(!showPass);
	}

	const showConfirmPassword = () => {
		if(!showConfirmPass){
		  setConfirmPasswordType('text');
		} else {
		  setConfirmPasswordType('password');
		}
		setConfirmShowPass(!showConfirmPass);
	}

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }

    const findFormErrors = () => {
        const { full_name, email, mobile_number, password, confirm_password, member_type } = formData
        let newErrors = {}

        
        // password errors
        if ( !full_name || full_name === '' ) newErrors.full_name = 'Name cannot be blank!'
        if ( !email || email === '' ) newErrors.email = 'Enter email address'
        if ( !mobile_number || mobile_number === '' ) newErrors.mobile = 'Enter mobile number'
        if ( !member_type || member_type === '' ) newErrors.member_type = 'Select your type'
        if ( !password || password === '' ) newErrors.mobile = 'Enter password'
        if ( !confirm_password || confirm_password === '' ) newErrors.confirm_password = 'Enter confirm password'
        if(confirm_password){
            if(password != confirm_password){
                newErrors.confirm_password = 'Password mismatch'
            }
        }
        
        if(email && !validateEmail(email)){
            newErrors.email = 'Your e-mail has been entered in the wrong format. Please check and try again';
          }
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }
	
	const handleSubmit = async (event) => { 
        const checkErrors = findFormErrors();
		
		const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        // console.log('check 2', Object.keys(checkErrors).length)
        if ( Object.keys(checkErrors).length > 0 ) {
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            // Create Rgistration
            // console.log(formData)
            await signUp(formData).then(res => {
                console.log('dd', res.payload.data)
                if(!res.payload.data.success && res.payload.data.errors){
                    Swal.fire({
                        title: 'Error!',
                        text: res.payload.data.errors[0],
                        icon: 'error',
                        confirmButtonText: 'Ok'
                      })
                }
                else if(res.payload.status && res.payload.status == 'true'){
                    navigate(`/login`);
                }
            })
        }
	}

    return (
        <div>
            <Header/>
            <section className='pt-5 pb-5 bg-dark'>
                <h3 className='text-center'>Sign Up</h3>
            </section>
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col xs={6}>
                            <Card className='shadow p-4'>
                                <Card.Body>
                                    <h2 className='text-center'>Sign Up</h2>
                                    <Button className='d-block w-100' variant='light'> <FaGoogle /> Sign up with google</Button>
                                    <form className='mt-4' noValidate onSubmit={handleSubmit}>
                                        <Form.Group className={ errors.full_name ? "input-error mb-3" : "mb-3"} controlId="formGroupFullName">
                                            <Form.Control type="text" placeholder="Full Name" name="full_name" onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.full_name }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className={ errors.email ? "input-error mb-3" : "mb-3"} controlId="formGroupEmail">
                                            <Form.Control type="email" placeholder="Email address" name="email" onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.email }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className={ errors.mobile ? "input-error mb-3" : "mb-3"} controlId="formGroupMobile">
                                            <Form.Control type="text" placeholder="Mobile Number" name="mobile_number" onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.mobile }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {/* <Form.Group className="mb-3" controlId="formGroupPassword">
                                            <Form.Control type="password" placeholder="Password" />
                                        </Form.Group> */}
                                        <InputGroup className="mb-3" controlId="formGroupPassword">
                                            <Form.Control
                                            placeholder="Password"
                                            type={passwordType}
                                            onChange={handleChange}
                                            className={ errors.password ? "input-error mb-3" : "mb-3"} 
                                            name="password"
                                            />
                                            <Button variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                            <Form.Control.Feedback type="invalid">
                                                { errors.password }
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                        <InputGroup className="mb-3" controlId="formGroupConfirmPassword">
                                            <Form.Control
                                            placeholder="Confirm Password"
                                            type={confirmpasswordType}
                                            onChange={handleChange}
                                            className={ errors.confirm_password ? "input-error mb-3" : "mb-3"}
                                            name="confirm_password"
                                            />
                                            <Button variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                            <Form.Control.Feedback type="invalid">
                                                { errors.confirm_password }
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                        <Form.Group as={Col} controlId="formGroupMemberType">
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="member_type" className={ errors.member_type ? "input-error mb-3" : "mb-3"}>
                                                <option>Choose Your Type</option>
                                                <option value="owner">Owner</option>
                                                <option value="dealer">Dealer</option>
                                                <option value="builder">Builder</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                { errors.member_type }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Button type="submit" className='d-block w-100 btn-lg mt-3'>Sign Up</Button>
                                        <div className='text-center mt-4'>Already have account? <Link to={`/login`}>Sign In</Link></div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* <SweetAlert2 {...swalProps} /> */}
                </Container>
            </section>
            <Footer/>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        loggedIn: state.customer.loggedIn
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          signUp: (post) => dispatch(actions.signUp(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);